/**
 * The single timezone frame for Primavera P6 imports.
 *
 * P6 XML exports timezone-naive timestamps ("2026-05-25T07:00:00"). The
 * CoreWebApi backend interprets naive strings in its host zone — CET/CEST
 * (verified against stored data: +02:00 in summer, +01:00 in winter) — so the
 * client parses them in the SAME zone (`iana`), or every re-imported date
 * diffs against the stored instant whenever the user's machine is elsewhere.
 *
 * The P6 calendars imported alongside those dates are stamped with the
 * matching Windows id (`windowsId`; RDrive calendars carry Windows ids, which
 * the main web app maps to IANA via CLDR). A calendar's working windows are
 * wall-clock times in the calendar's zone, so the calendar zone must be the
 * zone the activity timestamps were interpreted in — otherwise the walk, the
 * working-time durations and the SPA gantt evaluate 07:00-16:00 windows
 * 1-2h off the instants.
 *
 * Keep both halves in sync with the backend host timezone. The proper
 * long-term fix is for the backend to interpret naive P6 dates in the
 * project timezone (and these calendars would then take the project zone).
 */
export const P6_TIMEZONE = Object.freeze({
  iana: 'Europe/Amsterdam',
  windowsId: 'W. Europe Standard Time'
});
